<template>
    <v-app id="inspire">
        <div v-if="isAuthenticated">
            <snackbars></snackbars>
            <v-navigation-drawer v-model="drawer" app>
                <v-list dense nav>
                    <v-list-item v-for="(item, i) in navItems" :key="i" :to="{ name: item.to }" exact>
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-list dense nav>
                    <v-list-item v-for="item in adminNavItems" :key="item.title" :to="{ name: item.to }" exact>
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <div class="text-caption ml-3">&copy; {{ year }} WorldManager</div>
            </v-navigation-drawer>

            <v-app-bar app>
                <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

                <v-app-bar-title>World Manager</v-app-bar-title>
                <v-breadcrumbs :items="crumbs">
                    <template v-slot:divider>
                        <v-icon>mdi-chevron-right</v-icon>
                    </template>
                </v-breadcrumbs>
                <v-spacer></v-spacer>
                <div>Hi {{ userName }}!</div>
                <notification-bell v-if="isAuthenticated" />
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-account</v-icon>
                        </v-btn>
                    </template>
                    <div>
                        <v-btn-toggle v-if="themeLoaded" v-model="theme" borderless @change="updateTheme">
                            <v-btn value="light">
                                <span class="hidden-sm-and-down">Light</span>

                                <v-icon right>
                                    mdi-white-balance-sunny
                                </v-icon>
                            </v-btn>

                            <v-btn value="dark">
                                <span class="hidden-sm-and-down">Dark</span>

                                <v-icon right>
                                    mdi-weather-night
                                </v-icon>
                            </v-btn>
                        </v-btn-toggle>
                    </div>
                    <v-spacer></v-spacer>
                    <v-list>
                        <v-list-item :to="{ name: 'userProfile' }">
                            <v-list-item-icon>
                                <v-icon>mdi-account-details</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Profile</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="logout">
                            <v-list-item-icon>
                                <v-icon>mdi-exit-to-app</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Logout</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-progress-linear
                    :active="isProgressBarActive"
                    indeterminate
                    absolute
                    bottom
                    color="deep-purple accent-4"
                ></v-progress-linear>
            </v-app-bar>

            <v-main>
                <router-view></router-view>
            </v-main>
        </div>
        <v-container v-else>
            <v-row justify="center">
                <v-col cols="12" sm="5" class="text-center">
                    <v-card class="mt-10 pt-4 pb-10">
                        <v-card-title class="text-center">
                            <p class="display-1 flex-grow-1 dialogtitle">World Manager</p>
                        </v-card-title>
                        <v-card-text class="d-flex my-3">
                            <div class="d-flex flex-column flex-grow-1">
                                <v-spacer></v-spacer>
                                <v-divider class="mx-4"></v-divider>
                                <v-spacer></v-spacer>
                            </div>
                            <div>
                                <v-icon x-large color="primary">
                                    mdi-shield-lock
                                </v-icon>
                            </div>
                            <div class="d-flex flex-column flex-grow-1">
                                <v-spacer></v-spacer>
                                <v-divider class="mx-4"></v-divider>
                                <v-spacer></v-spacer>
                            </div>
                        </v-card-text>
                        <v-spacer></v-spacer>
                        <v-card-actions class="justify-center">
                            <v-btn class="px-10" color="secondary" x-large @click="gotoLogin">Log In</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-overlay :value="isLoggingOut" z-index="1000">
            <div class="text-center">
                <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
                <div class="mt-4">Logging out…</div>
            </div>
        </v-overlay>
    </v-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Snackbars from '@/components/Snackbars.vue'
import NotificationBell from '@/components/NotificationBell.vue'
export default {
    name: 'App',
    components: {
        Snackbars,
        NotificationBell,
    },
    data: () => ({
        drawer: null,
        theme: 'light',
        themeLoaded: false,
    }),
    computed: {
        ...mapState(['requestsInProgress', 'user', 'isLoggingOut']),
        ...mapGetters(['hasAnyEntityPermission', 'isAuthenticated', 'isAdmin']),
        isProgressBarActive() {
            return this.requestsInProgress > 0
        },
        userName() {
            return this.user ? this.user.firstName : ''
        },
        crumbs() {
            let pathArray = this.$route.path.split('/')
            pathArray.shift()
            let breadcrumbs = pathArray.reduce((breadcrumbArray, path, i) => {
                if (!path || !this.$route.matched[i]) return breadcrumbArray
                breadcrumbArray.push({
                    path: path,
                    to: breadcrumbArray[i - 1] ? '/' + breadcrumbArray[i - 1].path + '/' + path : '/' + path,
                    text: this.$route.matched[i].meta.breadCrumb || path,
                    exact: true,
                })
                return breadcrumbArray
            }, [])
            return breadcrumbs
        },
        navItems() {
            let items = [{ title: 'Home', icon: 'mdi-home', to: 'Home' }]
            if (this.hasAnyEntityPermission('plot'))
                items.push({ title: 'Plot Lines', icon: 'mdi-newspaper-variant-outline', to: 'plot' })
            if (this.hasAnyEntityPermission('monster'))
                items.push({ title: 'Monsters', icon: 'mdi-skull-outline', to: 'monster' })
            if (this.hasAnyEntityPermission('lammie'))
                items.push({ title: 'Lammie Requests', icon: 'mdi-card-bulleted', to: 'lammie' })
            if (this.hasAnyEntityPermission('encounter'))
                items.push({
                    title: 'Encounters',
                    icon: 'mdi-calendar-range',
                    to: 'encounter',
                })
            if (this.hasAnyEntityPermission('rumour'))
                items.push({ title: 'Rumours', icon: 'mdi-chat-alert-outline', to: 'rumour' })
            if (this.hasAnyEntityPermission('research'))
                items.push({ title: 'Research Requests', icon: 'mdi-library', to: 'research' })
            if (this.hasAnyEntityPermission('ritual'))
                items.push({ title: 'Ritual Circles', icon: 'mdi-google-circles-extended', to: 'ritualCircle' })
            if (this.hasAnyEntityPermission('network'))
                items.push({ title: 'Ritual Circle Networks', icon: 'mdi-lan', to: 'network' })
            return items
        },
        adminNavItems() {
            let items = []
            if (this.hasAnyEntityPermission('editTeams')) items.push({ title: 'Teams', icon: 'mdi-earth', to: 'teams' })
            if (this.hasAnyEntityPermission('editEvents'))
                items.push({ title: 'Events', icon: 'mdi-calendar-outline', to: 'events' })
            if (this.hasAnyEntityPermission('eventSlots'))
                items.push({ title: 'Event Timetables', icon: 'mdi-timetable', to: 'eventtimetable' })
            if (this.hasAnyEntityPermission('editResearchPeriod'))
                items.push({ title: 'Research Periods', icon: 'mdi-library-shelves', to: 'researchPeriods' })
            if (this.hasAnyEntityPermission('editUsers'))
                items.push({ title: 'Users', icon: 'mdi-account-multiple', to: 'users' })
            if (this.hasAnyEntityPermission('editUsers'))
                items.push({ title: 'Roles and Permissions', icon: 'mdi-shield-key', to: 'rolesAndPermissions' })
            if (this.isAdmin) items.push({ title: 'Entity Tags', icon: 'mdi-tag-multiple', to: 'tagsList' })
            if (this.hasAnyEntityPermission('systemPage'))
                items.push({ title: 'System Pages', icon: 'mdi-file', to: 'systemPages' })
            return items
        },
        year() {
            return new Date().getFullYear()
        },
    },
    mounted() {
        var theme = localStorage.getItem('wmtheme')
        this.updateTheme(theme)
        this.themeLoaded = true
    },
    methods: {
        updateTheme(name) {
            if (name === 'light') {
                this.$vuetify.theme.dark = false
            } else {
                this.$vuetify.theme.dark = true
            }
            this.theme = name
            localStorage.setItem('wmtheme', name)
        },
        gotoLogin() {
            this.$store.dispatch('gotoLogin')
        },
        logout() {
            this.$confirm({
                title: 'Confirm Logout?',
                body: 'Are you sure you want to logout?',
                confirmButtonText: 'Logout',
                cancelButtonText: 'Cancel',
            }).then(confirmResult => {
                if (confirmResult) {
                    this.$store.dispatch('gotoLogout')
                }
            })
        },
        navigate(linkName, params) {
            this.$router.push({ name: linkName, params: params })
        },
    },
}
</script>
<style>
.reader {
    max-width: 960px;
    margin: auto;
}
</style>
